import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { close_error_modal } from "../../../slices/Error_Modal/reducer";

const ErrorModal = () => {


const {open_modal , modal_message} = useSelector((state)=>state.Error_Modal)
const dispatch = useDispatch()

  return (
    <>
    {/* <Button color="primary" onClick={() => tog_center()}> Launch Demo Modal</Button> */}
     <Modal
          isOpen={open_modal}    
          centered
      >
          <ModalHeader className="modal-title" />

          <ModalBody className="text-center p-5">
              <lord-icon src="https://cdn.lordicon.com/hrqwmuhr.json"
                  trigger="loop" colors="primary:#121331,secondary:#08a88a" style={{ width: "120px", height: "120px" }}>
              </lord-icon>
              <div className="mt-4">
                  <h4 className="mb-3" style={{wordBreak:'break-word'}}>{modal_message}</h4>
                  <p className="text-muted mb-4"> </p>
                  <div className="hstack gap-2 justify-content-center">
                      <Button color="light" onClick={()=>{
                           dispatch(close_error_modal())
                      }}  >Close</Button>
                      {/* <Link to="#" className="btn btn-danger">Try Again</Link> */}
                  </div>
              </div>
          </ModalBody>
      </Modal> 
    </>
  )
}

export default ErrorModal
